<template>
  <div v-if="init" v-show="props.modelValue" class="my-page-modal" @update:visible="emits('update:modelValue', $event)" :bodyStyle="{ padding: 0 }">
    <div class="my-page-modal-top">
      <slot name="top"></slot>
    </div>
    <div class="my-page-modal-content">
      <div class="my-page-modal-left" v-if="Object.keys($slots).some((v) => v === 'left')">
        <slot name="left"></slot>
      </div>
      <div ref="myPageModal" class="my-page-modal-body" :style="newBodyStyle">
        <slot></slot>
      </div>
      <div class="my-page-modal-right" v-if="Object.keys($slots).some((v) => v === 'right')">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="my-page-modal-footer" v-if="Object.keys($slots).some((v) => v === 'footer')">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script setup>
  import { ref, defineProps, defineEmits, computed, defineExpose, watch, onMounted, onUnmounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  const props = defineProps({
    modelValue: {
      type: Boolean
    },
    bodyStyle: {
      type: Object,
      dafault: () => ({})
    },
    width: {
      type: Number,
      dafault: 700
    }
  });

  const init = ref(false);
  const newBodyStyle = computed(() => {
    return Object.assign({  }, props.bodyStyle);
  });
  const emits = defineEmits(['update:modelValue', 'cancel']);
  const myPageModal = ref();
  const router = useRouter();
  const route = useRoute();

  onMounted(() => {
    const element = document.querySelector('.my-layout-content');
    if (!element.classList.contains('relative')) {
      element.classList.toggle('relative');
    }
    if (route.query.showPageModel) {
      router.go(-1);
    }
  });

  onUnmounted(() => {
    const element = document.querySelector('.my-layout-content');
    if (element.classList.contains('relative')) {
      element.classList.toggle('relative');
    }
  });

  watch(() => props.modelValue, (value) => {
    // modelValue值改变时，确定是否需要加载组件
    init.value = value || init.value;
    // 如果展示页面，则跳转路由，否则返回路由
    if (value && !route.query.supportRefresh) {
      router.push({
        path: route.path,
        query: {
          ...route.query,
          showPageModel: 1
        }
      });
    } else {
      // if (route.query.showPageModel) {
      //   router.go(-1);
      // }
    }
  }, { immediate: true });


  watch(() => route.query, ({ showPageModel }) => {
    emits("update:modelValue", !!showPageModel);
  });

  defineExpose({
    myModal: myPageModal,
  });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.my-page-modal {
  position: absolute;
  left: 0;
  right: 0;
  top: 1px;
  bottom: 1px;
  background: white;
  z-index: 10;
  overflow-y: auto;
  .my-page-modal-body {
    margin: 20px 0;
    padding: 0 20px;
    min-height: 200px;
    max-height: calc(100vh - 290px);
    overflow: auto;
    flex: 1;
  }
  .my-page-modal-footer {
    padding: 10px 0 10px 80px;
  }
}
  .my-page-modal-content {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
  }
  .my-page-modal-right {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    overflow-y: auto;
  }
  .my-page-modal-left {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 20px 0;
    min-height: 200px;
    max-height: calc(100vh - 290px);
  }
</style>
